import groq from 'groq';

export const blockProfilePictureFields = groq`
person->
`;
